import {
  GENERAL_REQUEST_LOADING,

  TOOLS_ACCESS_USER_ACCOUNT_SUCCESS,
  LOGIN_SUCCESS,

  EMPLOYEE_FIELD_CHANGED,
  EMPLOYEE_PRINT_CLAIM_SUCCESS,
  EMPLOYEE_GET_BANKING_SUCCESS,
  EMPLOYEE_SET_BANKING_SUCCESS,
  EMPLOYEE_LOADING,
  EMPLOYEE_UPDATE,
  EMPLOYEE_UPDATE_FAIL,
  EMPLOYEE_UPDATE_SUCCESS,
  EMPLOYEE_AGREEMENT,
  EMPLOYEE_AGREEMENT_SUCCESS,
  EMPLOYEE_AGREEMENT_FAIL,
  EMPLOYEE_BANKING_IMAGE_ADD,
  EMPLOYEE_BANKING_IMAGE_ADD_SUCCESS,
  EMPLOYEE_BANKING_IMAGE_ADD_FAILED,
  EMPLOYEE_BANKING_IMAGE_RESET,
  AUTH_EMPLOYEE,
  AUTH_EMPLOYEE_FAIL,
  AUTH_EMPLOYEE_SUCCESS,
  EMPLOYEE_DEPENDANT_SUCCESS,
  EMPLOYEE_DEPENDANT_FAIL,
  EMPLOYEE_DEPENDANT_EDIT,
  EMPLOYEE_DEPENDANT_ADD,
  EMPLOYEE_DEPENDANT_DELETE,
  EMPLOYEE_DEPENDANT_EXTEND,
  EMPLOYER_EMPLOYEE_LIST_SUCCESS,
  ERROR_CLEAR,
  LOGOUT,
} from '../actions/types';

export const INITIAL_STATE = {
  employee: {},
  reportInput: {startdate: '', enddate: '', recordStart: 0, recordEnd: 50 },
  dependants: [],
  printForm: '',
  printUser: '',
  personalBanking: '',
  chequeImage: '',
  error: false,
  errors: {},
  success: false,
  message: '',
  loading: false,
};

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case TOOLS_ACCESS_USER_ACCOUNT_SUCCESS:
        return {
          ...INITIAL_STATE,
          employee: {
            CELLPHONE: action.data.user.CELLPHONE,
            CITY: action.data.user.CITY,
            DATE_OF_BIRTH: action.data.user.DATE_OF_BIRTH,
            EFFECTIVE_DATE: action.data.user.EFFECTIVE_DATE,
            EMAIL: action.data.user.EMAIL,
            EMPLOYEE: action.data.user.EMPLOYEE,
            FAX: action.data.user.FAX,
            FIRST_NAME: action.data.user.FIRST_NAME,
            GROUP_ADMIN: action.data.user.GROUP_ADMIN,
            LAST_NAME: action.data.user.LAST_NAME,
            NON_MEMBER_ADMIN_ONLY: action.data.user.NON_MEMBER_ADMIN_ONLY,
            POSTCODE: action.data.user.POSTCODE,
            PROVINCE: action.data.user.PROVINCE,
            STREET1: action.data.user.STREET1,
            STREET2: action.data.user.STREET2,
            TELEPHONE: action.data.user.TELEPHONE,
          },
          dependants: action.data.dependants,
          error: false,
          errors: {},
          loading: false,

        };
      case LOGIN_SUCCESS:
        return {
          ...INITIAL_STATE,
          employee: {
            CELLPHONE: action.data.user.CELLPHONE,
            CITY: action.data.user.CITY,
            DATE_OF_BIRTH: action.data.user.DATE_OF_BIRTH,
            EFFECTIVE_DATE: action.data.user.EFFECTIVE_DATE,
            EMAIL: action.data.user.EMAIL,
            EMPLOYEE: action.data.user.EMPLOYEE,
            FAX: action.data.user.FAX,
            FIRST_NAME: action.data.user.FIRST_NAME,
            GROUP_ADMIN: action.data.user.GROUP_ADMIN,
            LAST_NAME: action.data.user.LAST_NAME,
            NON_MEMBER_ADMIN_ONLY: action.data.user.NON_MEMBER_ADMIN_ONLY,
            POSTCODE: action.data.user.POSTCODE,
            PROVINCE: action.data.user.PROVINCE,
            STREET1: action.data.user.STREET1,
            STREET2: action.data.user.STREET2,
            TELEPHONE: action.data.user.TELEPHONE,
          },
          dependants: action.data.dependants,
          error: false,
          errors: {},
          loading: false,
        };
      case EMPLOYEE_LOADING:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_FIELD_CHANGED:
        return { ...state,
          employee: {
            ...state.employee,
            [action.fieldName]: action.fieldValue
          }
        };
      case AUTH_EMPLOYEE:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case AUTH_EMPLOYEE_SUCCESS:
        return { ...state, employee: (action.data)? action.data.employee : action.employee, dependants: (action.data)? action.data.dependants : action.dependants, error: false, errors: {}, loading: false };
      case AUTH_EMPLOYEE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false };
      case EMPLOYEE_PRINT_CLAIM_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, success: false, message: '', printForm: action.data.form, printUser: action.data.employee}
      case EMPLOYEE_AGREEMENT:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_AGREEMENT_SUCCESS:
        return { ...state, error: false, errors: {}, loading: false, success: true, message: action.data.message };
      case EMPLOYEE_AGREEMENT_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYEE_UPDATE:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_UPDATE_SUCCESS:
        return {
          ...state,
          error: false,
          employee: (action.data)? action.data.employee : action.employee,
          errors: {},
          loading: false,
          success: true,
          message: (action.data)? action.data.message : action.message
        };
      case EMPLOYEE_UPDATE_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYEE_DEPENDANT_EDIT:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_DEPENDANT_ADD:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_DEPENDANT_DELETE:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_DEPENDANT_EXTEND:
        return { ...state, error: false, errors: {}, loading: true, success: false, message: '' };
      case EMPLOYEE_DEPENDANT_SUCCESS:
        return {
          ...state,
          error: false,
          dependants: (action.data)? action.data.dependants : action.dependants,
          errors: {},
          loading: false,
          success: true,
          message: action.message
        };
      case EMPLOYEE_DEPENDANT_FAIL:
        return { ...state, error: true, errors: action.errors, loading: false, success: false, message: '' };
      case EMPLOYEE_BANKING_IMAGE_ADD:
        return {
          ...state,
          error: false,
          errors: {},
          loading: true
        };
      case EMPLOYEE_BANKING_IMAGE_ADD_SUCCESS:
        return {
          ...state,
          chequeImage: action.data,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYEE_BANKING_IMAGE_ADD_FAILED:
        return { ...state, error: true, errors: action.errors, loading: false };
      case EMPLOYEE_BANKING_IMAGE_RESET:
        return {
          ...state,
          chequeImage: INITIAL_STATE.chequeImage,
          error: false,
          errors: {},
          loading: false
        };
      case EMPLOYEE_GET_BANKING_SUCCESS:
        return { ...state,
          error: false,
          personalBanking: action.data.personalBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYEE_SET_BANKING_SUCCESS:
        return { ...state,
          error: false,
          personalBanking: action.data.personalBanking,
          chequeImage: INITIAL_STATE.chequeImage,
          errors: {},
          loading: false,
          success: true,
          message: action.data.message
        };
      case EMPLOYER_EMPLOYEE_LIST_SUCCESS:
        return { ...state,
          employee: INITIAL_STATE.employee
        };
      case GENERAL_REQUEST_LOADING:
        return { ...state, error: false, errors: {}};
      case ERROR_CLEAR:
        return { ...state, error: false, errors: {}, loading: false, success: false, message: '' };
      case LOGOUT:
        return INITIAL_STATE;
      default:
        return state;
    }
};

export default reducer;
